// ==============================|| USER MERCHANT PREFERENCES SCOPE ||============================== //
//
// The scope id every read and write is guarded by, composed here rather than at each call site: the
// store compares it for equality, so the auth flow's hydration and `hooks/usePreferencesScopeId`
// drifting apart would silently drop every write.

import type {
  UserMerchantPreferencesHydrationInput,
  UserMerchantPreferencesScopeIdInput,
  UserMerchantPreferencesScopeResolutionInput
} from 'model/types/user-merchant-preferences';

export function composePreferencesScopeId({ userId, merchantId }: UserMerchantPreferencesScopeIdInput): string | undefined {
  if (!userId || !merchantId) {
    return undefined;
  }

  return `${userId}:${merchantId}`;
}

export function resolveUserMerchantPreferencesScope({
  user,
  merchantId
}: UserMerchantPreferencesScopeResolutionInput): UserMerchantPreferencesHydrationInput | null {
  const scopeId = composePreferencesScopeId({ userId: user?.id, merchantId });
  const activeRole = merchantId ? user?.roles?.find((role) => role.merchant?.id === merchantId) : undefined;

  if (!scopeId || !activeRole) {
    return null;
  }

  // An empty bag still hydrates the scope, so reads fall back to defaults and the legacy
  // localStorage migration can still seed the cache and retry its write.
  return { scopeId, roleId: activeRole.id, metadata: activeRole.metadata ?? '{}' };
}
